import {
  SEND_PROSPECT_TO_API,
  SEND_PROSPECT_TO_API_SUCCESS,
  SEND_PROSPECT_TO_API_FAIL,
  SET_SCREENING_ERROR,
  RESET_SCREENING_ERROR,
  RESET_FORM_STEP,
  SET_LAST_PROSPECT_SAVED,
  SET_LAST_RO_PROSPECT_SAVED,
  RESET_LAST_PROSPECT_SAVED,
  RESET_LAST_RO_PROSPECT_SAVED,
  UPDATE_SCREENING_INFO
} from "../actions/sendProspectToAPI";
import { handleActions } from "../../utils/redux-utils";

export const initialState = {
  loading: false,
  resetStep: false,
  screeningError: {},
  lastProspect: {},
  lastProspectTime: "",
  lastRoProspect: {},
  lastRoProspectTime: "",
  screeningInfo: {}
};

export default handleActions(
  {
    [SEND_PROSPECT_TO_API]: state => ({
      ...state,
      loading: true
    }),
    [SEND_PROSPECT_TO_API_SUCCESS]: state => ({
      ...state,
      loading: false
    }),
    [SEND_PROSPECT_TO_API_FAIL]: state => ({
      ...state,
      loading: false
    }),
    [RESET_FORM_STEP]: (state, action) => ({
      ...state,
      resetStep: action.payload
    }),
    [SET_SCREENING_ERROR]: (state, action) => ({
      ...state,
      screeningError: action.payload
    }),
    [UPDATE_SCREENING_INFO]: (state, action) => ({
      ...state,
      screeningInfo: action.payload
    }),
    [RESET_SCREENING_ERROR]: state => ({
      ...state,
      screeningError: initialState.screeningError
    }),
    [SET_LAST_PROSPECT_SAVED]: (state, action) => ({
      ...state,
      lastProspect: action.payload,
      lastProspectTime: new Date()
    }),
    [RESET_LAST_PROSPECT_SAVED]: state => ({
      ...state,
      lastProspect: initialState.lastProspect,
      lastProspectTime: ""
    }),
    [SET_LAST_RO_PROSPECT_SAVED]: (state, action) => ({
      ...state,
      lastRoProspect: { ...action.payload },
      lastRoProspectTime: new Date()
    }),
    [RESET_LAST_RO_PROSPECT_SAVED]: state => ({
      ...state,
      lastRoProspect: initialState.lastRoProspect,
      lastRoProspectTime: ""
    })
  },
  initialState
);
